export const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0",
    transform: "translate(-50%, -50%)",
    borderRadius: "12px",
    zIndex: "1000",
    marginTop: "30px",
  },
};

export const viewDetailsModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0",
    transform: "translate(-50%, -50%)",
    borderRadius: "12px",
    zIndex: "1000",
    marginTop: "30px",

    width: "70%",
    maxWidth: "900px",
    maxHeight: "90vh",
    overflowY: "auto",
  },
};

export const computeCustomStyles = (size = "10%") => ({
  content: {
    top: size,
    left: size,
    right: size,
    bottom: size,
    // marginRight: "-50%",
    padding: "0",
    // transform: "translate(-50%, -50%)",
    borderRadius: "12px",
    zIndex: "1000",
    marginTop: "30px",
  },
});
